/**
 * Created by Elad_Swissa on 7/23/15.
 */

'use strict';

import * as ans from '@wix/answers-api';
import Sdk from '../sdk/sdk.srv';

class Search {

		/*@ngInject*/
		constructor(private $http: ng.IHttpService, private appConfig, private sdk: Sdk) {}

		articlesSearchApiPath = this.appConfig.apiPath + `/helpcenter/articles/search`;

		public search(text: string, pageSize?: number): ng.IPromise<ans.SearchResult<ans.Article>> {

				const contentFilters = this.sdk.getContentFilters();
				return this.$http.post(this.articlesSearchApiPath, {
						text: text,
						page: 1,
						pageSize: pageSize || 5,
						locale: this.appConfig.lang,
						searchable: true,
						spellcheck: true,
						...contentFilters
				})
				.then((response) => response.data as ans.SearchResult<ans.Article>);
		}
}

export default Search;
